import {
  createRoutesFromChildren,
  matchRoutes,
  RemixBrowser,
  useLocation,
  useNavigationType,
} from "@remix-run/react";
import { EXTERNAL_INTEGRATIONS_ENABLED } from "@repo/shared";
import * as Sentry from "@sentry/react";
import { StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

import { version } from "../version.json";

if (EXTERNAL_INTEGRATIONS_ENABLED.sentry) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      // eslint-disable-next-line import/namespace
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
    beforeSend(event) {
      if (import.meta.env.DEV) {
        return null;
      }
      return event;
    },
  });

  // eslint-disable-next-line import/namespace
  Sentry.setTags({
    version,
  });
}

hydrateRoot(
  document,
  <StrictMode>
    <RemixBrowser />
  </StrictMode>,
);
